import script from "./MultiSelectModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultiSelectModal.vue?vue&type=script&setup=true&lang=ts"

import "./MultiSelectModal.vue?vue&type=style&index=0&id=24d06ed1&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/environment/test_front_adachi/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24d06ed1"]])

export default __exports__